import { render } from "./FeeForm.vue?vue&type=template&id=c4615a36"
import script from "./FeeForm.vue?vue&type=script&lang=js"
export * from "./FeeForm.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__